// extracted by mini-css-extract-plugin
export default {"wrapper":"Stats_wrapper__A1KLU","statBox":"Stats_statBox__V0BYD","number":"Stats_number__7dsvW","label":"Stats_label__zHGYo"};